module.exports = __webpack_public_path__ + "img/21.8eb00f87.png";